import { render, staticRenderFns } from "./widget-row.vue?vue&type=template&id=620cd2ac&scoped=true"
import script from "./widget-row.vue?vue&type=script&lang=js"
export * from "./widget-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620cd2ac",
  null
  
)

export default component.exports